import { render, staticRenderFns } from "./FormLembrete.vue?vue&type=template&id=9a40c9e6&"
import script from "./FormLembrete.vue?vue&type=script&lang=js&"
export * from "./FormLembrete.vue?vue&type=script&lang=js&"
import style0 from "./FormLembrete.vue?vue&type=style&index=0&id=9a40c9e6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports